import { getCustomerById } from '@/lib/mock-customers';
import type { RiskLevelCode } from '@/lib/risk-level';

/** Collection Settings selection as chosen in the customer detail dropdowns. */
export interface CollectionSettingsSelection {
  /** Collection strategy id, or 'none' */
  collectionStrategyId: string;
  /** Statement template: 'none' (null, use company default) | '<id>' */
  statementTemplateSelection: string;
  /** Effective risk code derived from the risk level dropdown (e.g. 'high', 'none') */
  riskCode: string;
  /** Credit controller user id, or 'none' */
  creditControllerId: string;
  /** Account manager user id, or 'none' */
  accountManagerId: string;
}

/**
 * Persists the customer detail Collection Settings against the in-memory mock customer
 * so the selections round-trip after a refresh in demo mode.
 *
 * Statement template selection:
 * - 'none'  -> no assigned template (StatementTemplateId null; send falls back to company default)
 * - '<id>'  -> specific assigned template (StatementTemplateId id)
 *
 * The remaining dropdowns use the 'none' sentinel to clear the assignment.
 */
export function applyCollectionSettingsToMockCustomer(
  customerId: string,
  selection: CollectionSettingsSelection,
): void {
  const customer = getCustomerById(customerId);
  if (!customer) return;

  customer.collectionStrategyId = selection.collectionStrategyId === 'none' ? '' : selection.collectionStrategyId;
  customer.creditControllerId = selection.creditControllerId === 'none' ? undefined : selection.creditControllerId;
  customer.accountManagerId = selection.accountManagerId === 'none' ? undefined : selection.accountManagerId;
  customer.risk = selection.riskCode as RiskLevelCode;

  customer.statementTemplateId =
    selection.statementTemplateSelection === 'none' || selection.statementTemplateSelection === ''
      ? undefined
      : selection.statementTemplateSelection;
}
